module.exports = __webpack_public_path__ + "static/media/ae1.f1cfea27.png";